import { QuizOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { Box } from '@mui/material';
import { LessonQuestionI } from 'types';
import { colors } from 'Constants/Colors';
interface Props {
  currentQuestionIndex: number;
  questions: LessonQuestionI[];
}

const QuestionCounter = ({ currentQuestionIndex, questions }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Chip
        icon={<QuizOutlined />}
        label={`Pregunta ${currentQuestionIndex + 1}/${questions.length}`}
        variant="outlined"
        sx={{
          borderColor: colors.GREEN,
          color: colors.GREEN,
          '& .MuiChip-icon': { color: colors.GREEN },
        }}
      />
    </Box>
  );
};

export default QuestionCounter;
